import React from 'react';

import { gql } from '@apollo/client';
import { assertIsoDateTimeRange } from '@modernloop/shared/datetime';

import { ActivityLogInterviewerRsvpAccepted_ActivityLogFragment, ResponseStatus } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import ActivityLogContent from 'src/entities/ActivityLog/Helpers/ActivityLogContent';

import { ProposedTimeContent } from '../shared/InterviewerRsvp/ProposedTimeContent';

interface Fragments {
  activityLog: ActivityLogInterviewerRsvpAccepted_ActivityLogFragment;
}

const ActivityLogTaskInterviewerRsvpAccepted: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;
  // eslint-disable-next-line no-underscore-dangle
  if (!details || details.__typename !== 'ActivityLogInterviewerRsvpAcceptedDetails') {
    throw new Error(
      'ActivityLogInterviewerRsvpAcceptedDetails: details is not ActivityLogInterviewerRsvpAcceptedDetails'
    );
  }
  const { interviewName, comment, proposedTime } = details;

  return (
    <ActivityLogBase
      activityLog={activityLog}
      responseStatus={ResponseStatus.Accepted}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.acceptedInterview"
      actionLabelValues={{ interviewName }}
    >
      {comment ? <ActivityLogContent content={comment} /> : null}
      {proposedTime ? <ProposedTimeContent proposedTime={assertIsoDateTimeRange(proposedTime)} /> : null}
    </ActivityLogBase>
  );
};

ActivityLogTaskInterviewerRsvpAccepted.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogInterviewerRsvpAccepted_activityLog on ActivityLog {
      id
      details {
        __typename
        ... on ActivityLogInterviewerRsvpAcceptedDetails {
          __typename
          interviewName
          comment
          proposedTime {
            startAt
            endAt
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskInterviewerRsvpAccepted;
